import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { ErrorMessages, RegistrationStrings } from '../../../constants';
import { RegistrationSettings } from '../../../types/RegistrationSettings';
import Api from '../../api/api';

export const updateRegistrationSettings = async (
  publicRegistrationEnabled: boolean
): Promise<RegistrationSettings> => {
  const [response, bodyOrError] = await Api.patch('registration-settings', {
    publicRegistrationEnabled,
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useUpdateRegistrationSettings = () => {
  const queryClient = useQueryClient();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('updateRegistrationSettings', updateRegistrationSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries('getRegistrationSettings');
      setAlertSnackbar({
        message: RegistrationStrings.SETTINGS_UPDATED,
        severity: 'success',
        vertical: 'top',
      });
    },
    onError: () => {
      setAlertSnackbar({
        message: ErrorMessages.SERVER_ERROR,
        severity: 'error',
      });
    },
  });
};
